module.exports = __webpack_public_path__ + "static/media/girl4.999646a7.png";